import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { AbstractService } from '@common/services/abstract.service';
import { EncryptionProviderService } from '@common/services/encryption.service';
import { HTTP_METHODS } from '@common/services/service.constant';
import { Platform, AlertController } from '@ionic/angular';
import { CommonService } from '@common/services/common.service';
import { Device } from '@ionic-native/device/ngx';

@Injectable()

export class HeaderService extends AbstractService<any>{

    profilePic = new BehaviorSubject<string>("");

    constructor(
        http: HttpClient,
        encryptionProviderService: EncryptionProviderService,platform: Platform,alertController:AlertController, commonService:CommonService, device:Device ){
        super(http, encryptionProviderService,platform,alertController,commonService,device);
    }

    public logout(): Observable<any> {
        const url = '/logout'
        return this.request({
            method: HTTP_METHODS.POST,
            url: `${url}`,
            body: {},
        });
    }

    setProfilePicture(profilePic: string) {
        this.profilePic.next(profilePic);
    }

    getProfilePicture() {
        return this.profilePic.asObservable();
    }

    public getForceUpdateInfo(): Observable<any> {
        const url = '/info/version'
        return this.request({
            method: HTTP_METHODS.GET,
            url: `${url}`,
            body: {},
        });
    }
}
